import Swiper from "swiper";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";

export function initHeroSlider(): void {
  const sliders = document.querySelectorAll<HTMLElement>(
    ".hwk-blocks--hero-slider.swiper",
  );

  sliders.forEach((el) => {
    new Swiper(el, {
      modules: [Autoplay, EffectFade, Navigation, Pagination],
      effect: "fade",
      loop: true,
      speed: 500,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: el.querySelector<HTMLElement>(".swiper-button-next"),
        prevEl: el.querySelector<HTMLElement>(".swiper-button-prev"),
      },
      pagination: {
        el: el.querySelector<HTMLElement>(".swiper-pagination"),
        clickable: true,
      },
    });
  });
}
